import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, AlertTriangle } from 'lucide-react';
interface EpisodeViewScreenProps {
  onBack: () => void;
}
export function EpisodeViewScreen({
  onBack
}: EpisodeViewScreenProps) {
  return <motion.div className="min-h-screen w-full bg-black flex flex-col" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.8
  }} data-id="element-149">
      {/* Navigation */}
      <nav className="w-full p-6 z-30 absolute top-0 left-0 bg-gradient-to-b from-black/80 to-transparent" data-id="element-150">
        <button onClick={onBack} className="flex items-center text-white/70 hover:text-white transition-colors text-sm tracking-widest uppercase group" data-id="element-151">
          <ChevronLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-152" />
          Volver al menú
        </button>
      </nav>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center pt-24 pb-12 px-4 md:px-8 overflow-y-auto" data-id="element-153">
        {/* Video Container */}
        <motion.div className="w-full max-w-5xl aspect-video bg-black shadow-[0_0_50px_rgba(0,0,0,0.5)] border border-white/5 relative group mb-12" initial={{
        scale: 0.95,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} data-id="element-154">
          <video className="w-full h-full object-cover" controls controlsList="nodownload noplaybackrate" disablePictureInPicture onContextMenu={e => e.preventDefault()} poster="https://images.unsplash.com/photo-1478720568477-152d9b164e63?q=80&w=2500&auto=format&fit=crop" data-id="element-155">
            <source src="https://cdn.shopify.com/videos/c/o/v/46f24469e7894a26a2d058257b630f2c.mp4" type="video/mp4" data-id="element-156" />
            Your browser does not support the video tag.
          </video>
        </motion.div>

        {/* Info Section */}
        <div className="w-full max-w-3xl space-y-12" data-id="element-157">
          {/* Description */}
          <motion.div className="space-y-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} data-id="element-158">
            <h3 className="text-xl font-serif text-[var(--text-primary)] mb-4" data-id="element-159">
              En este episodio conocerás:
            </h3>
            <ul className="space-y-3 text-[var(--text-secondary)] font-light" data-id="element-160">
              <li className="flex items-center" data-id="element-161">
                <span className="w-1.5 h-1.5 bg-[var(--accent)] rounded-full mr-3" data-id="element-162" />
                La última noche de Carmen
              </li>
              <li className="flex items-center" data-id="element-163">
                <span className="w-1.5 h-1.5 bg-[var(--accent)] rounded-full mr-3" data-id="element-164" />
                La llamada misteriosa
              </li>
              <li className="flex items-center" data-id="element-165">
                <span className="w-1.5 h-1.5 bg-[var(--accent)] rounded-full mr-3" data-id="element-166" />
                Los tres principales sospechosos
              </li>
            </ul>
          </motion.div>

          {/* Warning Box */}
          <motion.div className="bg-[var(--bg-card)] border-l-4 border-[var(--accent)] p-6 md:p-8 relative overflow-hidden" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.9
        }} data-id="element-167">
            <div className="absolute top-0 right-0 p-4 opacity-5" data-id="element-168">
              <AlertTriangle className="w-24 h-24" data-id="element-169" />
            </div>

            <div className="relative z-10" data-id="element-170">
              <div className="flex items-center mb-4 text-[var(--accent)]" data-id="element-171">
                <AlertTriangle className="w-5 h-5 mr-2" data-id="element-172" />
                <span className="font-bold tracking-widest uppercase text-sm" data-id="element-173">
                  Importante
                </span>
              </div>
              <p className="text-[var(--text-primary)] text-lg mb-2" data-id="element-174">
                Este episodio incluye una pausa obligatoria para que
                investiguen.
              </p>
              <p className="text-[var(--text-secondary)]" data-id="element-175">
                No usen el celular.
              </p>
            </div>
          </motion.div>

          {/* Next Episode Button */}
          <motion.div className="flex justify-center pt-8" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.2
        }} data-id="element-176">
            <button className="px-8 py-4 border border-white/10 text-[var(--text-secondary)] uppercase tracking-widest text-sm hover:bg-white/5 hover:text-white hover:border-white/30 transition-all duration-300" data-id="element-177">
              Continuar al Episodio 2
            </button>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}